import React, { useContext, useEffect, useState, useCallback } from "react";
import useSnackbar from "./../../../hooks/useSnackbar";
import _ from "lodash";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  TextField,
  Checkbox,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Collapse
} from "@mui/material";

import FormControl from "@mui/material/FormControl";

import { useTheme } from "@mui/material/styles";

import RefreshIcon from "@mui/icons-material/Refresh";
import UndoIcon from "@mui/icons-material/Undo";
import SaveIcon from "@mui/icons-material/Save";
import LooksIcon from "@mui/icons-material/Looks";

import ContainerLoading from "../../../components/Loading/ContainerLoading";
import MyNumberInput from "../../Admin/components/Shared/myNumberInput";

import { formatDate } from "../../../utils/misc";

import UpdateLogRow from "./ErrorLogs/ErrorLogRow";

import EditDialog from "./Configuration/EditDialog";
import KioskThemePanel from "./KioskTheme/KioskThemePanel";

import { KEY_NAME_REGEX } from "../../../constants";

import HttpContext from "../../../contexts/HTTP/HttpContext";

import moment from "moment";

import { WORKFLOW_MODES } from "../../../constants";

function ServerSettings(props) {
  const theme = useTheme();
  const { get, post } = useContext(HttpContext);

  const [loading, setLoading] = useState(true);

  const [editDialogIsOpened, setEditDialogIsOpened] = useState(false);
  const [editDialogData, setEditDialogData] = useState(null);
  const [editDialogIndex, setEditDialogIndex] = useState(null);

  const [serverSetting, setServerSetting] = useState(null);

  const [hasChange, setHasChange] = useState(false);
  const stableSetHasChange = useCallback(value => {
    setHasChange(value);
  }, []);

  const [themeDialogOpen, setThemeDialogOpen] = useState(false);

  const { openSnackbar } = useSnackbar();

  const { reloadAdminHeader } = props;

  const loadData = async () => {
    setLoading(true);

    //Load data
    const res2 = await get("/kiosk/getServerSetting/ConsignAction");

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to load server settings",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res2.status == 403 || res2.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res2.status === 200) {
      const data = _.get(res2, "data");

      await setServerSetting(data);
    }

    setHasChange(false);
    setLoading(false);
  };

  const saveSettings = useCallback(async newpayload => {
    //const newsettings = { ...serverSetting, theme: newtheme };
    console.log("DEBUG [saveSettings] newpayload", newpayload);

    const res2 = await post("/kiosk/serverSetting/ConsignAction", newpayload);
    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");

      //SInce format can change, just reload from server
      openSnackbar({
        open: true,
        message: "Successfully updated!",
        variant: "alert",
        alert: {
          color: "success"
        },
        close: false
      });
      await loadData();
    }
  }, []);

  const isPositiveOrZeroNumber = str => {
    // Remove leading/trailing whitespace
    str = str.trim();

    // Check if it's a valid number and positive or zero
    const num = Number(str);
    return !isNaN(num) && num >= 0 && str.length > 0;
  };

  const EditSettings = index => {
    console.log("Configuration.EditSettings() index", index);
    setEditDialogIndex(index);
    setEditDialogData(setServerSetting);
    setEditDialogIsOpened(true);
  };

  const loadDetails = async id => {};

  useEffect(() => {
    (async () => {
      await loadData();
    })();
  }, []);

  return (
    <Grid
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h4">Kiosk Theme</Typography>
          {/* <Typography>View and edit your server settings</Typography> */}
        </div>
      </div>

      {serverSetting !== undefined && serverSetting !== null ? (
        <KioskThemePanel
          initialtheme={serverSetting.theme}
          open={themeDialogOpen}
          hasChange={hasChange}
          setHasChange={stableSetHasChange}
          loading={loading}
          // handleClose={(event, reason) => {
          //   // Prevent closing on backdrop click or escape key
          //   if (reason === "backdropClick" || reason === "escapeKeyDown") {
          //     return;
          //   }
          //   setThemeDialogOpen(false);
          // }}
          handleSaveEditChanges={async newtheme => {
            //console.log("newtheme", newtheme);

            await saveSettings({ ...serverSetting, theme: newtheme });
            reloadAdminHeader();

            // await setServerSetting({ ...serverSetting, theme: newtheme });
            // await setHasChange(true);
            // setThemeDialogOpen(false);
          }}
        />
      ) : (
        <TableBody>Loading</TableBody>
      )}
      {/* </Table>
      </TableContainer> */}
      <EditDialog
        open={editDialogIsOpened}
        editDialogData={editDialogData}
        editDialogIndex={editDialogIndex}
        handleClose={() => {
          setEditDialogIsOpened(false);
        }}
      />
    </Grid>
  );
}

export default ServerSettings;

function isKeyNameValid(name) {
  if (!name) return false;

  return KEY_NAME_REGEX.test(name);
}

function isKeyNameDuplicate(keys, name) {
  return keys.map(key => key.name).includes(name);
}

function getKeyNameHelperText(keys, name) {
  if (!isKeyNameValid(name)) {
    return "Invalid name";
  }

  if (isKeyNameDuplicate(keys, name)) {
    return "Name already in use";
  }

  return "";
}
